import { useEffect } from 'react'

import { useRouterState } from '@tanstack/react-router'
import { useStore } from 'zustand'

import { showUpdateModal } from '../components/UpdateModal'

import type { VersionService } from '../VersionService'

/**
 * Fecha o ciclo do lado do React: avisa o serviço quando a rota muda e exibe o
 * modal de major quando a política pede.
 *
 * O `IdleManager` já cobre o caso "usuário parado"; navegação cobre o outro
 * momento seguro — acabou de trocar de tela, não há passo em andamento. Quem
 * estivesse no meio de um teria registrado uma razão de bloqueio.
 */
export const useIdleReload = (service: VersionService) => {
  const pathname = useRouterState({ select: state => state.location.pathname })

  useEffect(() => {
    service.notifyNavigation()
  }, [service, pathname])

  const updateAvailable = useStore(service.store, state => state.updateAvailable)
  const latestVersion = useStore(service.store, state => state.latestVersion)

  useEffect(() => {
    let ativo = true

    if (!updateAvailable || !service.policy.shouldShowModal())
      return () => {
        ativo = false
      }

    void showUpdateModal().then(confirmado => {
      if (!ativo) return

      // Marcar como avisada antes de agir: o modal já foi mostrado para esta
      // versão e não deve reaparecer, inclusive quando "Atualizar agora" for
      // aceito e o reload ficar adiado por um fluxo crítico em andamento.
      service.dismissUpdate()

      if (confirmado) service.updateNow()
    })

    return () => {
      ativo = false
    }
  }, [service, updateAvailable, latestVersion])
}
